import {ApplicationRef} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {APP_VERSION} from "./version";

console.groupCollapsed(`Chapps Manager v${APP_VERSION}`)
console.log('Bootstrapping application …');


platformBrowserDynamic().bootstrapModule(AppModule)
    .then(moduleRef => {
        const applicationRef = moduleRef.injector.get(ApplicationRef);
        const componentRef = applicationRef.components[0];
        console.log('Finished bootstrapping');
        console.groupEnd();
    })
  .catch(err => console.log(err));

